import { render, staticRenderFns } from "./ProfileEditPopup.vue?vue&type=template&id=1fe0ccb2&"
import script from "./ProfileEditPopup.vue?vue&type=script&lang=js&"
export * from "./ProfileEditPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ProfileEditPopup.vue"
export default component.exports